export default "__VITE_PUBLIC_ASSET__e52d50cc__"